import { CustomerTypes, PersonalInfoFormActionType } from "app/hooks/";
import { useCheckoutInfoContext } from "pages/checkout/providers/CheckoutInfoProvider";
import Radio, { RadioVariant } from "shared/ui/radio";
import { concatClassnames } from "shared/utils/concatClassnames";

interface CheckoutInfoSwitchProps {
  className?: string;
}

const CheckoutInfoSwitch = ({ className }: CheckoutInfoSwitchProps) => {
  const { state, dispatch } = useCheckoutInfoContext();

  const updateType = (value: CustomerTypes) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_TYPE,
      payload: value,
    });
  };

  return (
    <div className={concatClassnames("gg-flex gg-gap-x-8", className)}>
      <Radio
        variant={RadioVariant.BOX}
        id="particulier"
        checked={state.type === CustomerTypes.PERSONAL}
        onChange={() => updateType(CustomerTypes.PERSONAL)}
      >
        Particulier
      </Radio>

      <Radio
        variant={RadioVariant.BOX}
        id="zakelijk"
        checked={!(state.type === CustomerTypes.PERSONAL)}
        onChange={() => updateType(CustomerTypes.BUSINESS)}
      >
        Zakelijk
      </Radio>
    </div>
  );
};
export default CheckoutInfoSwitch;
